import get from 'lodash/get';

export const CustomerStats = data => ({ activity: data.activity });

export const responseDataToCustomerStats = responseData => {
  return new CustomerStats({
    activity: get(responseData, 'attributes.lastActivity'),
  });
};

export const responseToCustomerStats = response => {
  return responseDataToCustomerStats(response.data.data);
};
